var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-text2 text-center text-4xl mt-6"},[_vm._v("No reports available at this time.")])])
}]

export { render, staticRenderFns }